export default __webpack_public_path__ + "static/media/guia-mobile-dark-4.3c6cda9c.png";